import { property } from '@pristine-ts/metadata';
import { ClientQuestionnaireStatusEnum } from '../enums/client-questionnaire/client-questionnaire-status.enum';
import { ClientQuestionnaireKeynameEnum } from '../enums/client-questionnaire/client-questionnaire-keyname.enum';

export class ClientQuestionnaireIndexModel {
  @property()
  id: string;

  @property()
  ownerId: string;

  @property()
  organizationId: string;

  @property()
  status: ClientQuestionnaireStatusEnum;

  @property()
  keyname: ClientQuestionnaireKeynameEnum;

  @property()
  clientName: string;

  @property()
  clientIdentityId?: string;

  @property()
  clientEmail?: string;

  @property()
  createdAt: Date;

  @property()
  updatedAt: Date;
}